export enum vehicleTypes  {
  MOTO = 1,
  CAMIÓN = 2,
  MIXTO = 3,
}
